import React from 'react';
import { CardData } from '@nvs/gatsby-theme-leap-core/src/components/domains/confirmation/components/services/card/index';
import { Service } from '@nvs/gatsby-theme-leap-core/src/components/hoc/context/product/configuration-model';
import classNames from 'classnames';

import CardLeft from '../../../../../../../../components/card-left';
import CardRight from '../../../../../../../../components/card-right';

const FtoCard: React.FC<{ service: Service; data: CardData; printMode?: boolean }> = ({
	service,
	data,
	printMode = false,
}) => {
	return (
		<div
			className={classNames(
				'flex justify-center rounded-2xl max-w-xl mx-auto w-full flex flex-row font-novartis text-novartis-font h-[180px] sm:h-[317px]',
				{
					'shadow-leap': !printMode,
					'border border-font divide-x divide-font':
						printMode,
				}
			)}>
			<CardLeft data={data} service={service} defaultClassName={''}
				titleClassName={
					'text-xl sm:text-4xl leading-5 sm:leading-9 font-bold text-center flex flex-col gap-1.5 sm:gap-3.5 w-24 sm:w-32 [&_span]:text-sm [&_span]:sm:text-xl [&_span]:font-normal'
				}
				printMode={printMode} />
			<CardRight data={data} printMode={printMode} />
		</div>
	);

}

export default FtoCard;